/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GUFEvent
 */
export interface GUFEvent {
  /**
   *
   * @type {string}
   * @memberof GUFEvent
   */
  readonly uuid?: string;
  /**
   * Event type: Height, NewLicense, WellFunction, Closure, etc.
   * @type {string}
   * @memberof GUFEvent
   */
  eventName: string;
  /**
   *
   * @type {Date}
   * @memberof GUFEvent
   */
  eventDate: Date;
  /**
   *
   * @type {object}
   * @memberof GUFEvent
   */
  metadata: object;
  /**
   *
   * @type {object}
   * @memberof GUFEvent
   */
  sourcedocumentData: object;
  /**
   *
   * @type {Date}
   * @memberof GUFEvent
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GUFEvent
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof GUFEvent
   */
  guf: string;
  /**
   *
   * @type {string}
   * @memberof GUFEvent
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the GUFEvent interface.
 */
export function instanceOfGUFEvent(value: object): value is GUFEvent {
  if (
    (!("eventName" in (value as Record<string, any>)) &&
      !("event_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["eventName"] === undefined &&
      (value as Record<string, any>)["event_name"] === undefined)
  )
    return false;
  if (
    (!("eventDate" in (value as Record<string, any>)) &&
      !("event_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["eventDate"] === undefined &&
      (value as Record<string, any>)["event_date"] === undefined)
  )
    return false;
  if (!("metadata" in value) || value["metadata"] === undefined) return false;
  if (
    (!("sourcedocumentData" in (value as Record<string, any>)) &&
      !("sourcedocument_data" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["sourcedocumentData"] === undefined &&
      (value as Record<string, any>)["sourcedocument_data"] === undefined)
  )
    return false;
  if (!("guf" in value) || value["guf"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GUFEventFromJSON(json: any): GUFEvent {
  return GUFEventFromJSONTyped(json, false);
}

export function GUFEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): GUFEvent {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    eventName: json["event_name"],
    eventDate: new Date(json["event_date"]),
    metadata: json["metadata"],
    sourcedocumentData: json["sourcedocument_data"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    guf: json["guf"],
    dataOwner: json["data_owner"],
  };
}

export function GUFEventToJSON(json: any): GUFEvent {
  return GUFEventToJSONTyped(json, false);
}

export function GUFEventToJSONTyped(
  value?: Omit<GUFEvent, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    event_name: value["eventName"],
    event_date: value["eventDate"].toISOString().substring(0, 10),
    metadata: value["metadata"],
    sourcedocument_data: value["sourcedocumentData"],
    guf: value["guf"],
    data_owner: value["dataOwner"],
  };
}
